import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  stepContainer: {
    display: 'flex',
    paddingLeft: '24px',
    // paddingTop: '10px',
    // paddingBottom: '10px',
    // paddingRight: '10px',
    alignItems: 'flex-start',
    gap: '16px',
    background: 'var(--background-progress-viewer-step, #FFF)',
    width: '394px',
    ': last-child': {
      borderBottomLeftRadius: '16px',
      borderBottomRightRadius: '16px',
      borderTopRightRadius: '0px',
      borderTopLeftRadius: '0px',
    },
  },
  lineSeparator: {
    width: '1px',
    background: '#E5E5E5',
    alignSelf: 'stretch',
  },
  stepContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '4px',
    position: 'relative',
    paddingTop: 'var(--padding-progress-viewer-step, 8px)',
    paddingBottom: 'var(--padding-progress-viewer-step, 8px)',
    paddingRight: '24px',
  },
  stepTitle: {
    color: '#333',
    fontFamily: tokens.fontFamilyBase,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '21px',
    letterSpacing: '-0.14px',
  },
  stepDescription: {
    color: '#333',
    fontFamily: tokens.fontFamilyBase,
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '18px',
    letterSpacing: '-0.12px',
    opacity: 0.5,
  },
  statusIndicator: {
    top: 'var(--top-progress-viewer-step, 12px)',
    height: '12px',
    width: '12px',
    left: '-22.5px',
    position: 'absolute',
  },
});
